import { useDispatch, useSelector } from "react-redux"
import ToolBar from "../../components/ToolBar";
import BootstrapTable from 'react-bootstrap-table-next';
import { warehouseActions, helperActions } from '../../_actions';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import WarehouseForm from "../../containers/warehouses/WarehouseForm";
import Dialog from "../../components/Dialog";
import { useState, useEffect } from "react";
import AccessMenu from "../../_helpers/access-menu";

const defaultSorted = [{
    dataField: 'warehouse_id',
    order: 'asc'
}, {
    dataField: 'config_name',
    order: 'asc'
}, {
    dataField: 'config_value',
    order: 'asc'
}, {
    dataField: 'notes',
    order: 'asc'
}];

const RemoteFilter = ({ data, page, sizePerPage, onTableChange, totalSize, warehouseList }) => {
    const { selected } = useSelector(state => state.warehouse)
    const { menus } = useSelector(state => state.authentication);
    const dispatch = useDispatch();

    const rowEvents = {
        onDoubleClick: (e, row, rowIndex) => {
            if (AccessMenu.validAccess(menus, 5703)) {
                dispatch(warehouseActions.updateWarehouse(row))
                dispatch(helperActions.showForm(true))
            }

        },
        onClick: (e, row, rowIndex) => {
            if (AccessMenu.validAccess(menus, 5704)) {
                dispatch(warehouseActions.updateWarehouse(row))
            }
            
        }
    };

    const columns = [{
        dataField: 'id',
        text: 'ID',
        hidden: true
    }, {
        dataField: 'warehouse_id',
        text: 'Warehouse ID',
        filter: selectFilter({
            options: warehouseList
        }),
        sort: true,
        headerStyle: (colum, colIndex) => {
            return { width: '200px', textAlign: 'center' };
        },

    }, {
        dataField: 'config_name',
        text: 'Config Name',
        filter: textFilter(),
        sort: true,
        headerStyle: (colum, colIndex) => {
            return { width: '300px', textAlign: 'center' };
        }
    }, {
        dataField: 'config_value',
        text: 'Config Value',
        filter: textFilter(),
        sort: true,
        headerStyle: (colum, colIndex) => {
            return { width: '100px', textAlign: 'center' };
        }
    }, {
        dataField: 'notes',
        text: 'Notes',
        filter: textFilter(),
        sort: true,
        headerStyle: (colum, colIndex) => {
            return { width: '500px', textAlign: 'center' };
        }
    }];

    const handleOnSelect = (row, isSelect) => {


        if (isSelect) {

            dispatch(warehouseActions.onSelectWarehouse([row.id]))
        } else {
            dispatch(warehouseActions.onSelectWarehouse([]))

        }

    }
    const selectRow = {
        mode: 'checkbox',
        selected: selected,
        clickToSelect: true,
        onSelect: handleOnSelect,
        hideSelectAll: true,

    };



    return <BootstrapTable
        bootstrap4
        remote
        keyField="id"
        data={data}
        columns={columns}
        filter={filterFactory()}
        pagination={paginationFactory({ page, sizePerPage, totalSize, "withFirstAndLast": false })}
        onTableChange={onTableChange}
        rowEvents={rowEvents}
        defaultSorted={defaultSorted}
        selectRow={selectRow}
        noDataIndication={'no results found'}
    />;
};

const WarehouseConfigList = () => {
    const { height, currentpage, currentSizePerPage, showForm, showDialog, warehouseList } = useSelector(state => state.helper);
    const dispatch = useDispatch();
    const { data, selected, warehouse_id, config_name, id } = useSelector(state => state.warehouse);
    const [_filters, setFilters] = useState({})
    const [_sorting, setSorting] = useState({})
    const [_paging, setPaging] = useState({})
    const [_first, setFirst] = useState({})
    const [_last, setLast] = useState({})


    const [mounted, setMounted] = useState(false)

    if (!mounted) {
        dispatch(helperActions.getWarehouseList())
    }

    useEffect(() => {
        setMounted(true)
        // eslint-disable-next-line
    }, []);

    const handleTableChange = (type, { filters, sortField, sortOrder, page, sizePerPage }) => {

        dispatch(warehouseActions.onSelectWarehouse([]))
        let sorting = { [sortField]: sortOrder }
        const paging = { currentpage, page, currentSizePerPage, sizePerPage }
        let first = {}
        let last = {}
        if (data.length > 0) {
            first = data[0]
            last = data[data.length - 1]
        }

        setFilters(filters)
        setSorting(sorting)
        setPaging(paging)
        setFirst(first)
        setLast(last)
        dispatch(warehouseActions.getWarehouseConfigList({}, filters, sorting, paging, first, last, type));
    }

    const _createWarehouseConfig = () => {
        dispatch(warehouseActions.createWarehouse({}))
        dispatch(helperActions.showForm(true))
    };

    const _deleteWarehouseConfig = () => {

        dispatch(helperActions.showDialog(true))
    }

    const _handleClose = () => {
        dispatch(helperActions.showDialog(false))
    }

    const _handleSubmit = () => {
        dispatch(warehouseActions.deleteWarehouseConfig(id, warehouse_id, config_name, _filters, _sorting, _paging, _first, _last, 'sort'))
    }

    return (

        <div>
            <ToolBar menu="Warehouse Config"
                create={_createWarehouseConfig}
                delete={_deleteWarehouseConfig} showDeleted={selected.length > 0} />
            <div style={{ position: "relative", height: height, overflow: "auto" }}>

                <RemoteFilter

                    data={data}
                    page={currentpage}
                    sizePerPage={currentSizePerPage}
                    totalSize={data.length > 0 ? data[0].tot_rec : 0}
                    onTableChange={handleTableChange}
                    warehouseList={warehouseList}
                />
                {showForm && <WarehouseForm />}
                {showDialog && <Dialog handleClose={_handleClose} handleSubmit={_handleSubmit}
                    message={"Delete Warehouse Config '" + warehouse_id + " " + config_name + "'?"} />}

            </div>
        </div>
    )

}
export default WarehouseConfigList
